import moment, { MomentInput } from 'moment/moment';

//Set authorization token automatically for API calls
const utils = {
    formatDate: (date: MomentInput, format = 'L HH:mm'): string =>
        moment(date).format(format),
    toTitleTextUnderscore: (text: string): string => {
        const splitText = text.replaceAll('_', ' ').toLowerCase();
        const result = splitText.replace(/([A-Z])/g, ' $1');
        return result.charAt(0).toUpperCase() + result.slice(1);
    },
    toTitleText: (text: string): string => {
        const result = text.replace(/([A-Z])/g, ' $1');
        return result.charAt(0).toUpperCase() + result.slice(1);
    },
    splitCamelcaseString: (string: string): string =>
        string.replace(/([a-z0-9])([A-Z])/g, '$1 $2'),
    dateFromYearDay: (year: number, day: number): Date => {
        const date = new Date(year, 0); // initialize a date in `year-01-01`
        const dayInMs = (day - 1) * 24 * 60 * 60 * 1000;
        return new Date(date.getTime() + dayInMs); // add the number of days
    },
    dayOfYear: (date: Date): number => {
        const dateDiff =
            date.getTime() - new Date(date.getFullYear(), 0, 0).getTime();
        const diff = dateDiff / 1000 / 60 / 60 / 24;
        return Math.floor(diff);
    },
    toUserFriendlySize: (bytes: number) => {
        const i = Math.floor(Math.log(bytes) / Math.log(1024));
        const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

        // @ts-ignore
        return `${(bytes / Math.pow(1024, i)).toFixed(2) * 1} ${sizes[i]}`;
    },
    formatUtcDate: (date: any, format = 'L HH:mm') =>
        moment.utc(date).format(format),
    upsertItem: (array, element) => {
        const i = array.findIndex(
            (_element) => _element.userId === element.userId
        );
        if (i > -1) array[i] = element;
        else array.push(element);
        return array;
    },
    removeObjectFromList: (array, id) => {
        return array.filter((el) => {
            return el.id !== id;
        });
    },
    removeUserFromList: (array, id) => {
        return array.filter((el) => {
            return el.userId !== id;
        });
    },
    findAllByKey: (obj: any, keyToFind: string) => {
        return (
            Object.entries(obj).reduce(
                (acc, [key, value]) =>
                    key === keyToFind
                        ? // @ts-ignore
                          acc.concat(value)
                        : typeof value === 'object' && value
                        ? acc.concat(utils.findAllByKey(value, keyToFind))
                        : acc,
                []
            ) || []
        );
    },
    findByValue: (o: any, val: string, match?: string) => {
        if (o === val) return o;
        if (isNaN(o) || o === Infinity || !o || typeof o !== 'object') return;
        if (Object.values(o).includes(val)) return o;
        let n;
        for (n of Object.values(o)) {
            // @ts-ignore
            if (match === 'partial' && n.id.includes(val)) {
                return n;
            } else {
                // @ts-ignore
                const found = utils.findByValue(n, val);
                if (found && found.id === val) return found;
            }
        }
    },
};

export default utils;
